/* eslint-disable no-unused-vars */
import React from "react";
import { PaginationTotalStandalone } from "react-bootstrap-table2-paginator";
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

export function PaginationToolbar(props) {
  const { isLoading, paginationProps } = props;
  const {
    sizePerPageList,
    sizePerPage,
    totalSize,
    onSizePerPageChange = [
      { text: "3", value: 3 },
      { text: "5", value: 5 },
      { text: "10", value: 10 }
    ]
  } = paginationProps;
  const style = {
    width: "75px"
  };

  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    inputRoot: {
      backgroundColor: "#EBEDF3",
    },
    formControl: {
      margin: theme.spacing(1),
      width: 100,
      padding: '4px 14px!important',
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0
      },
    },
    formControlInput: {
      margin: theme.spacing(1),
      width: 100,
      padding: '4px 14px!important',
      "& .MuiOutlinedInput-root": {
        backgroundColor: "#EBEDF3",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0
      },
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
      backgroundColor: "#EBEDF3",
    }
  }));

  const classes = useStyles();

  return (
    <div className="d-flex align-items-center py-3">
      {isLoading && (
        <div className="d-flex align-items-center">
          <div className="mr-2 text-muted">Loading...</div>
          <div className="spinner spinner-primary mr-10"></div>
        </div>
      )}
      <FormControl variant="outlined" className={classes.formControlInput}>
        <Select
          selectEmpty
          disabled={totalSize === 0}
          value={sizePerPage}
          onChange={(e) => {
            onSizePerPageChange(e.target.value);
          }}
          classes={{ root: classes.formControlInput }}
          InputProps={{
            classes: {
              input: classes.formControlInput
            }
          }}
        >
          {sizePerPageList.map(option => {
            return (
              <MenuItem key={option.text} value={option.value}>{option.text}</MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <PaginationTotalStandalone className="text-muted" {...paginationProps} />
    </div>
  );
}
